import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { en, fr } from './i18n';
import { openHelpPanel } from '../utils/openHelpPanel';
import { CustomerServiceContext } from './CustomerServiceContext';
import Link from './Link';

export interface ContactInfoProps {}

const ContactInfo = () => {
    const { i18n, t } = useTranslation('customer-service');
    i18n.addResourceBundle('en', 'customer-service', en, true, true);
    i18n.addResourceBundle('fr', 'customer-service', fr, true, true);

    const ctx = useContext(CustomerServiceContext);

    return (
        <section className="tsc-contact-us">
            <h1 className="tsc-contact-us__title">{t('contactInfoTitle')}</h1>
            <div className="tsc-contact-us__text">
                <p className="tsc-contact-us__text--bold">{t('chatWithOurCustomerService')}</p>
                <p>{t('chatWithOurCustomerServiceDate')}</p>
            </div>
            <button className="tsc-contact-us__livechat" onClick={openHelpPanel}>
                {t('liveChat')}
            </button>
            <div className="tsc-contact-us__text">
                <p className="tsc-contact-us__text--bold">{t('callOurCustomerServiceTeam')}</p>
                <p>{t('callOurCustomerServiceTeamDate')}</p>
                <p>{t('callOurCustomerServiceTeamDate2')}</p>
            </div>
            <div className="tsc-contact-us__text tsc-contact-us__text--top-space">
                <p className="tsc-contact-us__text--bold">{t('callOurSalesTeam')}</p>
                <p>{t('callOurSalesTeamDate')}</p>
            </div>
            <div className="tsc-contact-us__inquiries-block">
                <span className="tsc-contact-us__inquiries-block__text">{t('contactUsInquiryText')}</span>
                <div className="tsc-contact-us__inquiries-block__form-types">
                    <Link
                        href="/pages/customer-service/email-inquiry"
                        onClick={() => {
                            ctx.setView('article');
                            ctx.setContact('email-inquiry');
                            ctx.setUrlName('email-inquiry');
                        }}
                        className="tsc-contact-us__inquiries-block__form-types__button"
                    >
                        {t('generalEmailInquiriesText')}
                    </Link>

                    <Link
                        href="/pages/customer-service/billing-refund-inquiry"
                        onClick={() => {
                            ctx.setView('article');
                            ctx.setContact('billing-refund-inquiry');
                            ctx.setUrlName('billing-refund-inquiry');
                        }}
                        className="tsc-contact-us__inquiries-block__form-types__button"
                    >
                        {t('billingRefundEmailInquiriesText')}
                    </Link>
                </div>
                <span className="tsc-contact-us__inquiries-block__text tsc-contact-us__inquiries-block__text--light">
                    {t('ifYouLikeToSendUsFeedback')}{' '}
                    <Link
                        href="/pages/customer-service/send-feedback"
                        onClick={() => {
                            ctx.setView('article');
                            ctx.setContact('send-feedback');
                            ctx.setUrlName('send-feedback');
                        }}
                    >
                        {t('feedbackForm')}
                    </Link>
                    .
                </span>
            </div>
        </section>
    );
};

export default ContactInfo;
